import apiDispatcher from "@/utils/api-dispatcher";
import {
  GET_CHAT_CONTACT_LIST,
  GET_CHAT_MESSAGES,
  CONNECT_SOCKET,
  BLOCK_CONTACT,
  UNBLOCK_CONTACT,
  IGNORE_CONTACT,
  DELETE_CONVERSATION,
  GET_PROFILE_ID,
  DELETE_MULTIPLE_CONVERSATION,
  SAVE_CONTACT
} from "@/utils/api-url";
import Base from "./base";

const uniqueSlugToSenderType = {
  athlete: "AthleteProfile",
  clubCoach: "ClubCoach",
  collegeCoach: "Coach"
};

export default class Chat extends Base {
  constructor(params = {}) {
    super(params);
    this.id = params["_id"] || params["id"];
    this.key = params["_id"] || params["id"];
    this.receiverStatus = params["receiverStatus"] || "";
    this.lastMessageTime = params["lastMessageTime"] || "7:45 PM";
    this.lastConversation = params["lastConversation"] || "";
    this.receiverId = this["receiverId"] || {};
    this.lastMessageId = this["lastMessageId"] || {};
    this.allMessegeRead = params['allMessegeRead'] || this.allMessegeRead || false
  }

  static resourceName() {
    return "conversation";
  }

  static getMessage(params) {
    return apiDispatcher(GET_CHAT_MESSAGES(params));
  }

  static getContactList(params) {
    const profileId = this.profileId();
    return apiDispatcher(GET_CHAT_CONTACT_LIST(params, profileId));
  }

  static blockUser(params) {
    const senderId = this.profileId();
    const receiverId = params.receiverId;
    return apiDispatcher(BLOCK_CONTACT(senderId, receiverId));
  }

  static unblockUser(params) {
    const senderId = this.profileId();
    const receiverId = params.receiverId;
    return apiDispatcher(UNBLOCK_CONTACT(senderId, receiverId));
  }

  static ignoreUser(params) {
    const senderId = this.profileId();
    const receiverId = params.receiverId;
    return apiDispatcher(
      IGNORE_CONTACT({ senderId, receiverId, isIgnore: params.isIgnore })
    );
  }

  static saveUser(params) {
    const senderId = this.profileId();
    const receiverId = params.receiverId;
    return apiDispatcher(
      SAVE_CONTACT({
        senderId,
        receiverId,
        isContactSaved: params.isContactSaved
      })
    );
  }

  static deleteMultipleConversations(params) {
    return apiDispatcher(DELETE_MULTIPLE_CONVERSATION(params));
  }

  static delete(data) {
    return apiDispatcher(DELETE_CONVERSATION(data));
  }

  static connectSocket(params) {
    return apiDispatcher(CONNECT_SOCKET(params));
  }

  static getProfile() {
    const userId =
      Chat.userType() === "athlete" ? Chat.profileId() : Chat.userId();
    return apiDispatcher(
      GET_PROFILE_ID({
        userTypeUrl: Chat.userTypeUrl(),
        userId
      })
    );
  }

  static senderType() {
    return uniqueSlugToSenderType[this.userType()];
  }

  static receiverType(permission) {
    return uniqueSlugToSenderType[permission];
  }

  static formatReceiverInfo(receiverInfo = {}) {
    return {
      imageUrl: receiverInfo.profileImage || receiverInfo.image,
      name: receiverInfo.athletename || receiverInfo.coachname,
      description: getDescriptionByUniqueSlug(receiverInfo),
      state: getState(receiverInfo),
      city: getCity(receiverInfo)
    };
  }
}

const getDescriptionByUniqueSlug = profile => {
  if (profile.uniqueSlug === "collegeCoach")
    return getCollegeCoachDescription(profile);
  else if (profile.uniqueSlug === "clubCoach")
    return getClubCoachDescription(profile);
  return getPlayerDescription(profile);
};

const getCollegeCoachDescription = profile =>
  `${profile.position == undefined ? '': profile.position} at ${profile.CollegeId.collegeName == undefined ? '' :profile.CollegeId.collegeName}`;

const getClubCoachDescription = profile =>
  `${profile.position == undefined ? '': profile.position} at ${profile.clubId && profile.clubId.clubName == undefined ? '': profile.clubId.clubName}`;

const getPlayerDescription = profile => {
  let graduationYear =
    profile.graduationYear === "College Transfer"
      ? "College Transfer"
      : `${profile.graduationYear == undefined
        ? ''
        : `Graduation Year: ${profile.graduationYear} -`}`;
        let profilePosition = `${profile.position &&
          profile.position.map(pos => pos.name).join(", ")}`
  return `${graduationYear} ${profilePosition.length > 0 ? profilePosition + '-': ''} ${
    profile.heightInFeet
  }'${profile.heightInInch}" ${profile.weight == undefined ? '':`-${profile.weight}lbs`}`;
};

const getState = profile => {
  if (!profile.uniqueSlug) return "";
  if (profile.uniqueSlug === "collegeCoach")
    return profile.CollegeId.state.name;
  else if (profile.uniqueSlug === "clubCoach") return profile.clubId.state.name;
  return profile.state && profile.state.name;
};

const getCity = profile => {
  if (!profile.uniqueSlug) return "";
  if (profile.uniqueSlug === "collegeCoach") return profile.CollegeId.city;
  else if (profile.uniqueSlug === "clubCoach") return profile.clubId.city;
  return profile.city;
};
